import Axios from 'axios';

class AdminUsersService {
  getAll(search, page) {
    return Axios.get('/admin/users', { params: { search, page } })
      .then(({ data }) => data);
  }

  getUserRoles(userId) {
    return Axios.get(`/admin/users/${userId}/user_roles`)
      .then(({ data }) => data);
  }

  updateUserRole(userId, newRoleIds) {
    return Axios.put(`/admin/users/${userId}/update_user_role`, { new_role_ids: newRoleIds })
      .then(({ data }) => data);
  }
}

export default new AdminUsersService();
